import { render, staticRenderFns } from "./EditCardModal.vue?vue&type=template&id=67e8621e&scoped=true"
import script from "./EditCardModal.vue?vue&type=script&lang=js"
export * from "./EditCardModal.vue?vue&type=script&lang=js"
import style0 from "./EditCardModal.vue?vue&type=style&index=0&id=67e8621e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e8621e",
  null
  
)

export default component.exports